<div class="row mt-2">
  <div class="col-md-12">
    <ag-grid-angular #agGrid class="ag-theme-sg-bootstrap-condensed" [gridOptions]="gridOptions!"
      [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="permanentMonitoringItems" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
